import { api } from "@/api/api";
import ToastAlert from "@/components/molecules/ToastAlert";
import { AUTH_EVENTS } from "@/constants/amplitude.constants";
import { isEmpty } from "lodash";
import { QUERY_PARAMS } from "../constants/storage.constants";
import { TOAST_TYPES } from "../data/enums/toast";
import Amplitude from "../services/amplitude.service";
import useSignUpStore from "../store/useSignUpStore";
import { CreatorSignupType, SignUpOTPType } from "../types/signup.types";
import { getCurrentURL, getErrorMessage, getReferrer, getScreenWidth } from "../utils/commons";
import { getFromLocal } from "../utils/storage.util";
import { getUTMFieldsFromLocalStorage } from "../utils/utm.util";

const setIsFormLoading = useSignUpStore.getState().setIsFormLoading;

const SignupController = {
  emailSignup: (
    signupDetails: CreatorSignupType
  ): Promise<{
    response: boolean;
    domain?: any;
    message?: string;
    old_graphy_user?: boolean;
    userId?: string;
  }> => {
    setIsFormLoading(true);
    return new Promise(async (resolve, reject) => {
      try {
        //   POST API request
        let signupParams: CreatorSignupType = {
          ...signupDetails,
        };
        const gref = getFromLocal("gref");
        if (gref && typeof gref === "string") signupParams.gref = gref;

        const utmFields = getUTMFieldsFromLocalStorage();
        if (!isEmpty(utmFields)) signupParams.utmFields = utmFields;

        const otherParams = getFromLocal(QUERY_PARAMS);
        if (!isEmpty(otherParams) && typeof otherParams === "object" && otherParams !== null) {
          
          // Filter out skipOnboarding to ensure all users go through onboarding
          // Safe destructuring with null check
          let filteredOtherParams = { ...otherParams };
          if (filteredOtherParams.hasOwnProperty('skipOnboarding')) {
            delete filteredOtherParams.skipOnboarding;
          }
          signupParams = { ...signupParams, ...filteredOtherParams };
        }

        if (window.location.pathname.split("/")[1] === "kr") {
          signupParams.orgCountryCode = "kr";
        } else {
          signupParams.orgCountryCode = "";
        }

        const emailSignup = await api.feature.signup.emailSignup(signupParams);
        setIsFormLoading(false);
        const method = signupDetails.signupType === "google"
          ? "google"
          : signupDetails.phone
            ? "phone"
            : "email";

        new Amplitude().sendEvent({
          type: AUTH_EVENTS.SIGNUP_STATUS.LABEL,
          properties: {
            [AUTH_EVENTS.SIGNUP_STATUS.PROPERTIES.current_url]: getCurrentURL(),
            [AUTH_EVENTS.SIGNUP_STATUS.PROPERTIES.screen_width]: getScreenWidth(),
            [AUTH_EVENTS.SIGNUP_STATUS.PROPERTIES.utm_params]: getUTMFieldsFromLocalStorage(),
            [AUTH_EVENTS.SIGNUP_STATUS.PROPERTIES.referrer]: getReferrer(),
            [AUTH_EVENTS.SIGNUP_STATUS.PROPERTIES.status]: emailSignup.data.response ? "success" : "failure",
            [AUTH_EVENTS.SIGNUP_STATUS.PROPERTIES.user_id]: emailSignup.data.userId ?? "",
            [AUTH_EVENTS.SIGNUP_STATUS.PROPERTIES.reason]: emailSignup.data.message ?? "",
            [AUTH_EVENTS.SIGNUP_STATUS.PROPERTIES.user_type]: emailSignup.data.old_graphy_user ? "existing_user" : "new_user",
            [AUTH_EVENTS.SIGNUP_STATUS.PROPERTIES.visitor_id]: localStorage.getItem('graphy_visitor_id') ?? "",
            [AUTH_EVENTS.SIGNUP_STATUS.PROPERTIES.method]: method,
          } as { [key: string]: string },
          ...(emailSignup.data.userId ? { userId: emailSignup.data.userId } : {}),
        });

        resolve(emailSignup.data);
      } catch (error) {
        const errorMsg = getErrorMessage(error);
        ToastAlert({
          toastType: TOAST_TYPES.ERROR,
          message: errorMsg,
        });

        setIsFormLoading(false);
        reject(error);
      }
    });
  },
  verifyOTP: (
    OTPSignUpDetails: SignUpOTPType
  ): Promise<{
    response: boolean;
    message?: string;
  }> => {
    setIsFormLoading(true);
    return new Promise(async (resolve, reject) => {
      try {
        //   POST API request
        let otpParams: SignUpOTPType = {
          ...OTPSignUpDetails,
        };

        const otpVerification = await api.feature.signup.otpVerify(otpParams);
        setIsFormLoading(false);

        resolve(otpVerification.data);
      } catch (error) {
        const errorMsg = getErrorMessage(error);
        ToastAlert({
          toastType: TOAST_TYPES.ERROR,
          message: errorMsg,
        });

        setIsFormLoading(false);
        reject(error);
      }
    });
  },
};

export default SignupController;
